import useTracker from './hooks/internal/useTracker';

const Tracker = () => {
  useTracker();

  return false;
};

export default Tracker;
